import styled from '@emotion/styled';
import React, { FC } from 'react';
import Modal from '~ComponentsImproved/Modal';
import useModal from '~ComponentsImproved/Modal/useModal';
import { useButton, useI18n, useLicenses } from '~Hooks';
import { Box, Button } from '~Styles';
import { ModalContent } from '~Styles/modal';
import NewBookingForm from './NewBookingForm';

const ModalWrapper = styled(ModalContent)`
  background-color: var(--colorBlueGray1200);
`;

interface Props {
  onComplete?: (bookingId: string, date: string) => void;
}

const NewBooking: FC<Props> = ({ onComplete }) => {
  const { i18n } = useI18n();
  const newBookingModal = useModal();
  const licenses = useLicenses();

  const newBookingButton = useButton({
    onClick: newBookingModal.toggle,
  });

  return (
    <>
      <Box>
        {licenses.hasBookings && (
          <Button {...newBookingButton}>{i18n('Bookings.NewBooking')}</Button>
        )}
      </Box>

      <Modal
        isShowing={newBookingModal.isShowing}
        hide={newBookingModal.toggle}
        backdropClose={false}>
        <ModalWrapper>
          <NewBookingForm onClose={newBookingModal.toggle} onComplete={onComplete} />
        </ModalWrapper>
      </Modal>
    </>
  );
};

export default NewBooking;
